import { Component, OnInit } from '@angular/core';
import { Company, Profile } from '@cyborg-monorepo/hunter/common';
import { AuthService } from '../../../../auth/auth.service';

@Component({ standalone: false, 
  templateUrl: './cs.component.html',
  styleUrls: ['./cs.component.scss'],
})
export class CompanySettingsComponent implements OnInit {
  public admins: Array<Profile> = [];
  public company: Company;

  constructor(private authService: AuthService) {}

  public ngOnInit(): void {
    this.company = this.authService.user$.value.company;
  }
}
